import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowUpRight } from "lucide-react";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/motion/Reveal";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

export default function SeoLandingpages() {
  return (
    <SectionContainer id="seo-landingpages">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <SectionLabel number="/ 08" label="SEO-Landingpages" />
          <SectionHeading>Eine indexierbare Seite pro Fahrzeug. Konsequent.</SectionHeading>
          <SectionLead>
            Standard-Fahrzeugseiten sind für Suchmaschinen Rauschen. Wir machen aus jedem
            Fahrzeug einen SEO-Asset mit Schema.org, interner Verlinkung, Conversion-Logik
            und Long-Tail-Sichtbarkeit.
          </SectionLead>

          <StaggerGroup as="ul" className="mt-8 space-y-3" delayChildren={0.02} staggerChildren={0.06}>
            {[
              "Strukturierte Daten (Vehicle, Offer, Product)",
              "Long-Tail-Optimierung pro Modell und Standort",
              "Interne Verlinkung über Marken-/Modell-Hubs",
              "Automatische Aktualisierung bei Bestandsänderung",
              "Conversion-Tracking + Lead-Capture pro Seite",
            ].map((t) => (
              <StaggerItem key={t} as="li" y={16} className="flex items-start gap-3 text-sm text-slate-700">
                  <span className="mt-0.5 inline-flex items-center justify-center size-5 rounded-full bg-cyan-50 border border-cyan-200">
                    <CheckCircle2 className="size-3 text-cyan-600" />
                  </span>
                  {t}
              </StaggerItem>
            ))}
          </StaggerGroup>

          <Reveal delay={0.12} className="mt-8 flex flex-wrap gap-3">
            <Link to="/seo-beispiel" data-testid="seo-example-link">
              <span data-track="cta_click" data-cta="seo_example" data-location="seo_section" className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white rounded-md px-5 py-2.5 text-sm font-medium transition-colors">
                Beispiel-Landingpage ansehen <ArrowUpRight className="size-4" />
              </span>
            </Link>
            <Link to="/audit">
              <span className="inline-flex items-center gap-2 border border-slate-200 hover:border-slate-300 bg-white text-slate-900 rounded-md px-5 py-2.5 text-sm">
                Bestand prüfen lassen
              </span>
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-6">
          <Reveal>
            <BeforeAfterSlider
              beforeSrc="/screenshots/11_empty_state.webp"
              afterSrc="/screenshots/06_dienstleister_overview.webp"
              beforeLabel="Vorher"
              beforeNote="Score 31/100"
              afterLabel="Nachher"
              afterNote="Score 96/100"
            />
          </Reveal>

          <Reveal delay={0.1}>
            <div className="bg-white border border-slate-200 rounded-lg p-5">
              <div className="flex items-center justify-between">
                <p className="label-mono text-slate-500">Indexierungs-Verlauf · 90 Tage</p>
                <p className="font-mono text-[11px] text-emerald-700">+62% indexierte URLs</p>
              </div>
              <div className="mt-4 h-20 flex items-end gap-1">
                {[18, 22, 19, 28, 31, 33, 30, 36, 41, 43, 47, 52, 55, 58, 60, 64, 68, 72, 70, 76, 81, 84, 86, 91, 88, 93, 95, 92, 97, 99].map((h, i) => (
                  <div key={i} className="flex-1 bg-gradient-to-t from-cyan-500 to-teal-400 rounded-sm" style={{ height: `${h}%` }} />
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </SectionContainer>
  );
}
